export default {"src":"https://images-cdn.curipod.com/d-3d27c7f2/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};